export default {
  placeholders: {
    delivery_zip_code: 'Postnummer',
    delivery_city: 'By',
    delivery_street_number: 'Husnummer',
    delivery_street_name: 'Vejnavn',
    type_your_address: 'Skriv din adresse',
  },
  errors: {
    address_suggestions_unavailable: 'Adresseforslag kunne ikke indlæses. Du kan stadig indtaste din adresse nedenfor.',
  },
  buttons: {
    retry: 'Prøv igen',
  },
};
